import React, { useState, useEffect } from "react"
import api, { setAuthToken } from "./api/axiosInstance"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { auth } from "./firebase"

import LoaderFullPage from "./components/Loaders"

// Layout
import Layout from "./layout"

// Pages
import Login from "./pages/Login"

// HFMA Page TEMP
import HFMA from "./pages/HFMA"

// Routes
import RoutesBuilder from "./components/Routes"

import { GET } from "./config/constants"

import useTriggerDataLayer from "./hooks/useTriggerDataLayer"

// Context
import { UserContext } from "./context/userContext"

function App() {
  const [user, setUser] = useState(null)
  const [cssLoaded, setCssLoaded] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [triggerDataLayer] = useTriggerDataLayer()

  useEffect(() => {
    const getUserProfile = async (authUser) => {
      setIsLoading(true)
      try {
        const fetchUserProfile = await api.post(`/${GET.USER_PROFILE}`, {
          email: authUser.email,
        })
        const userData = fetchUserProfile.data.data || null
        const jwt = `Bearer ${fetchUserProfile.data.token}`
        setAuthToken(jwt)
        if (userData && userData.organization_alias) {
          const link = document.createElement("link")
          link.rel = "stylesheet"
          link.type = "text/css"
          link.href = `/styles/${userData.organization_alias}.css`
          console.log("ORG===>", userData.organization_alias)
          link.onload = () => setCssLoaded(true)
          document.head.appendChild(link)
        } else {
          setCssLoaded(true) // If no organization, still allow the app to render
        }
        setUser(userData)
        triggerDataLayer("login", userData)
      } catch (error) {
        setUser(null)
        setCssLoaded(true) // Allow the app to render on error
        console.log("Error getting User Profile.", error)
      } finally {
        setIsLoading(false)
      }
    }

    const unsubscribe = auth.onAuthStateChanged((authUser) => {
      if (
        authUser &&
        authUser.emailVerified &&
        authUser.multiFactor.enrolledFactors.length > 0
      ) {
        getUserProfile(authUser)
      } else {
        setUser(null)
        setCssLoaded(true) // Allow the app to render if no user is authenticated or email not verified
      }
    })

    return () => unsubscribe()
  }, [])

  const HandleRoutes = () => {
    if (!cssLoaded || isLoading) {
      return <LoaderFullPage />
    }

    if (user?.organization_alias === "hfma") {
      return (
        <UserContext.Provider value={user}>
          <Routes>
            <Route path="*" element={<HFMA />} />
          </Routes>
        </UserContext.Provider>
      )
    }

    if (user) {
      return (
        <UserContext.Provider value={user}>
          <Layout>
            <RoutesBuilder />
          </Layout>
        </UserContext.Provider>
      )
    }

    return (
      <Routes>
        <Route path="*" element={<Login />} />
      </Routes>
    )
  }

  return (
    <Router>
      <HandleRoutes />
    </Router>
  )
}

export default App
